import {
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  CardTitle
} from "@/components/shadcn/card";
import { AppointmentActionDropdown } from "../appointment/actions";

export const CurrentAppointment = (props) => {

  const { appointment } = props;

  return (
    <Card>
      <CardHeader class="pb-2 flex justify-between flex-row items-center">
          <div>
            <CardTitle>{appointment.patient}</CardTitle>
            <CardDescription class="text-sm">{appointment.doctor}</CardDescription>
          </div>
          <div class="flex gap-2 items-center">
            <AppointmentActionDropdown onAction={props.onAction} key={appointment.key} status={"Current"} />
          </div>
        </CardHeader>
      <CardContent>
        <p>Slot: {appointment.slot}</p>
        <p>Room: {appointment.room}</p>
      </CardContent>
    </Card>
  );
}
